import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { getFlightLogoUrl } from '@/utils/images'
import ImageBlock from '@/components/imageBlock'

type SegmentTabProps = {
    airlineCode: string
    airlineName: string
    isMultiAirline: boolean
    from: string
    to: string
    departureTime: string
    arrivalTime: string
    duration: string
    stopsText: string
    formattedDate: string
}
const SegmentTab: React.FC<SegmentTabProps> = ({
    airlineCode,
    airlineName,
    isMultiAirline,
    from,
    to,
    departureTime,
    arrivalTime,
    duration,
    stopsText,
    formattedDate
}) => {
    return (
        <Container className="flex flex-middle">
            <Container className="c-pointer flex flex-column flex-middle" style={{ minWidth: '94px' }}>
                <Container className="c-pointer" style={{ height: '24px', width: '24px' }}>
                    <ImageBlock
                        path={getFlightLogoUrl(airlineCode)}
                        height={24}
                        width={24}
                        altText={airlineCode}
                        isMultiAirline={isMultiAirline}
                        customClass="br-4 o-hidden"
                    />
                </Container>
                <Typography variant="B3" className="mt-1 c-pointer ws-nowrap t-truncate" css={{ maxWidth: '80px' }}>
                    {airlineName}
                </Typography>
            </Container>
            <Container className="pl-2 c-pointer">
                <Typography variant="P2" color="subheading" className="lh-20 c-pointer">
                    {`${from} -> ${to} · ${formattedDate}`}
                </Typography>
                <Typography variant="B1" className="mt-1 c-pointer">
                    {`${departureTime} - ${arrivalTime} · ${duration} (${stopsText})`}
                </Typography>
            </Container>
        </Container>
    )
}

export default SegmentTab
